export async function isDisposableEmail(email: string): Promise<boolean> {
  const domain = email.split('@')[1]?.toLowerCase().trim()
  if (!domain) return false
  const { DISPOSABLE_DOMAINS } = await import('./disposable-domains')
  return DISPOSABLE_DOMAINS.has(domain)
}
